import { Box, FormLabel, Heading, Input, Stack } from "@chakra-ui/react";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import { toast } from "react-toastify";
import MainModel from "../../../../components/Models/main-model";
import { closeCreateGroup } from "../../../../modules/admin-modules/models/Actions";
import { getAllCoursesRequest } from "../../../../modules/superadmin-modules/courses/Actions";
import {
  createGroupRequest,
  editGroupRequest,
} from "../../../../modules/superadmin-modules/groups/Actions";

const AddGroup = ({ isAdd, data, setSelectedData }) => {
  const openGroup = useSelector((state) => state.model.isOpen2);
  const { courses } = useSelector((state) => state.courses);
  const isLoading = useSelector((state) => state.superadminGroups.iaLoading);
  const dispatch = useDispatch();
  useEffect(() => {
    if (openGroup) {
      if (courses?.length == 0) dispatch(getAllCoursesRequest());
    }
  }, [openGroup, courses]);

  const coursesOptions = courses?.map((data) => {
    return { value: data.id, label: data.name };
  });
  const colourStyles = {
    control: (styles) => ({
      ...styles,
      width: "100%",
      background: "#f5f5f5",
      color: "#690000",
      borderRadius: "16px",
    }),
    option: (styles) => ({ ...styles, color: "#690000" }),
  };

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
    reset,
  } = useForm({
    defaultValues: !isAdd ? data : {},
    shouldUnregister: true,
  });

  const header = (
    <Box>
      <Heading textAlign="center" color="main_1" fontSize="24px">
        {isAdd ? "إضافة مجموعة" : "تعديل مجموعة"}
      </Heading>
    </Box>
  );
  const onSubmit = (values) => {
    let formData = new FormData();
    const total = { ...data, ...values };
    for (let key in total) {
      formData.append(key, total[key]);
    }
    const action = () => {
      dispatch(closeCreateGroup());
      setSelectedData({});
      reset();
    };

    if (isAdd) {
      if (values.course_id) {
        dispatch(createGroupRequest(formData, action));
      } else {
        toast.error("اختر السنة الدراسية");
      }
    } else {
      formData.append("_method", "PUT");
      dispatch(
        editGroupRequest({
          id: data?.id,
          formData: formData,
          action: action,
        })
      );
    }
  };

  const closeFunc = () => {
    dispatch(closeCreateGroup());
    setSelectedData({});
    reset();
  };
  return (
    <MainModel
      isLoading={isLoading}
      header={header}
      closeFunc={closeFunc}
      openVar={openGroup}
      buttonTitle={" حفظ التغيرات"}
      buttonFunc={handleSubmit(onSubmit)}
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <Stack spacing={5} dir="rtl" w="100%">
          <Box w="55%">
            <FormLabel>اسم المجموعة : </FormLabel>

            <Input
              type={"text"}
              borderColor={errors?.name?.message ? "red" : "gray.200"}
              placeholder={"ادخل اسم المجموعة"}
              size="md"
              bg="#f5f5f5"
              defaultValue={data?.name}
              _focus={{ outline: "none" }}
              {...register("name", { required: "هذه المعلومات مطلوبة" })}
            />
          </Box>

          <Box w="55%">
            <FormLabel>المواد الدراسية : </FormLabel>
            <Select
              options={coursesOptions}
              defaultValue={{
                label: data?.course?.name,
                value: data?.course?.id,
              }}
              onChange={(data) => setValue("course_id", data.value)}
              styles={colourStyles}
              placeholder="المادة"
              name="course_id"
            />
          </Box>
          <Box w="55%">
            <FormLabel>النوع : </FormLabel>
            <Select
              options={[
                { label: "online", value: 0 },
                { label: "center", value: 1 },
              ]}
              defaultValue={{ label: data?.name, value: data?.type }}
              onChange={(data) => setValue("type", data.value)}
              styles={colourStyles}
              placeholder="النوع"
              name="type"
            />
          </Box>
        </Stack>
      </form>
    </MainModel>
  );
};

export default AddGroup;
